module.exports = __webpack_public_path__ + "static/img/tm-1.bb25733.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/tm-1.jpg
// module id = /0u9
// module chunks = 0